import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Divider } from 'ui-components/components/divider';
import { Text, TextType } from 'ui-components/components/text';

import Global from '../../../../../../../store/global-selectors';
import { DetailField } from '../../../../components/detail-field/detail-field';
import { ReadonlyProductGrid } from '../../components/readonly-product-grid/readonly-product-grid';
import { messages as drawerMessages } from '../../messages';
import drawerStyles from '../../styles.module.less';
import { messages } from './messages';
import styles from './styles.module.less';

import type { CreateTransferOrderFormData, Warehouse } from '../../types';

type ConfirmTransferStepProps = {
  formData: CreateTransferOrderFormData;
};

export const ConfirmTransferStep = ({ formData }: ConfirmTransferStepProps) => {
  const inventoryWarehouses = useSelector(Global.selectSellerInventoryWarehouses) as Warehouse[];

  const uniqueProductCount = useMemo(() => {
    return formData.products.filter((product) => product.locations.some((loc) => loc.quantity > 0)).length;
  }, [formData.products]);

  const originWarehouseName = inventoryWarehouses.find((w) => w.inventoryWarehouseId.toString() === formData.originWarehouseId)?.name ?? '';

  const destinationWarehouseName =
    inventoryWarehouses.find((w) => w.inventoryWarehouseId.toString() === formData.destinationWarehouseId)?.name ?? '';

  return (
    <div className={drawerStyles['content-container']}>
      <div className={drawerStyles['section-header']}>
        <Text textType={TextType.H4} value={messages.confirmStepHeader} />
        <Text textType={TextType.Paragraph} value={messages.confirmStepDescription} />
      </div>

      <div className={styles['confirm-section']}>
        <div className={styles['confirm-section-content']}>
          <div className={styles['details-grid']}>
            <DetailField label={messages.originWarehouseDisplayLabel} value={originWarehouseName} />
            <DetailField label={messages.destinationWarehouseDisplayLabel} value={destinationWarehouseName} />
            <DetailField label={drawerMessages.orderDateLabel} value={formData.orderDate} />
            <DetailField label={drawerMessages.expectedDeliveryDateLabel} value={formData.expectedDeliveryDate} />
            <DetailField label={drawerMessages.referenceNumberLabel} value={formData.referenceNumber} />
          </div>
          <DetailField label={drawerMessages.notesLabel} value={formData.notes} />
        </div>
      </div>

      <Divider className={drawerStyles['horizontal-divider']} />

      <div className={styles['confirm-section']}>
        <div className={styles['confirm-section-header']}>
          <Text
            formattedMessageValues={{ count: uniqueProductCount }}
            textType={TextType.Label}
            value={messages.productsToTransferHeader}
          />
        </div>
        <div className={styles['confirm-section-content']}>
          <ReadonlyProductGrid products={formData.products} />
        </div>
      </div>
    </div>
  );
};
